import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { SeatPickerContextInstance } from '../types/context';
import { SeatPickerLegendItem } from './legend-item';
const b = bemClassBuilder('v-seat-picker-legend');
export const SeatPickerLegend = observer(({ usedAppearanceRuleIds }) => {
    const { config } = useContext(SeatPickerContextInstance);
    const legendItems = config.legend.items;
    return (_jsx("ul", { className: b.block(), children: legendItems
            .filter(item => !item.appearanceRuleId || usedAppearanceRuleIds.has(item.appearanceRuleId))
            .map((item, index) => (_jsx(SeatPickerLegendItem, { legendItem: item }, item.label + index.toString()))) }));
});
SeatPickerLegend.displayName = 'SeatPickerLegend';
//# sourceMappingURL=legend.js.map